import { render } from "./FaqTab.vue?vue&type=template&id=53f1cb27"
import script from "./FaqTab.vue?vue&type=script&lang=js"
export * from "./FaqTab.vue?vue&type=script&lang=js"

import "./FaqTab.vue?vue&type=style&index=0&id=53f1cb27&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__